import React, { Suspense, memo } from 'react';
import { Spin } from 'antd';

/**
 * 懒加载包装组件
 * 用于包装需要懒加载的组件
 */
const LazyWrapper = memo(({ 
  children, 
  fallback = <Spin size="large" style={{ display: 'block', textAlign: 'center', padding: '50px' }} />,
  error = null 
}) => {
  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  );
});

LazyWrapper.displayName = 'LazyWrapper';

/**
 * 错误边界组件
 * 用于捕获懒加载组件的错误
 */
class LazyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('LazyWrapper Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '50px', 
          textAlign: 'center',
          color: '#ff4d4f'
        }}>
          <h3>组件加载失败</h3>
          <p>请刷新页面重试</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            刷新页面
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

/**
 * 带错误边界的懒加载包装组件
 */
const LazyWrapperWithErrorBoundary = memo(({ children, ...props }) => {
  return (
    <LazyErrorBoundary>
      <LazyWrapper {...props}>
        {children}
      </LazyWrapper>
    </LazyErrorBoundary>
  );
});

LazyWrapperWithErrorBoundary.displayName = 'LazyWrapperWithErrorBoundary';

export default LazyWrapperWithErrorBoundary;
export { LazyWrapper, LazyErrorBoundary };
